import cogotoast from 'cogo-toast';

import { subscribeOn } from '~/state/bridge';
import { getSelectedInstagramId } from '~/state/Campaign/selectors';

import { get_server_url } from './common';

let instagram_actor_id = null;
subscribeOn(getSelectedInstagramId, (id) => {
  instagram_actor_id = id;
});

const getPreview = (path, data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(
    key,
    typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key],
  ));

  return fetch(get_server_url(path), {
    mode: 'cors',
    credentials: 'include',
    body: formData,
    method: 'POST',
  })
    .then(res => res.text());
};

export const validate = (shouldContinue, alert) => getAdditionalArgs => () => {
  let additionalArgs = null;
  if (getAdditionalArgs) {
    additionalArgs = getAdditionalArgs();
  }

  if (shouldContinue(additionalArgs)) {
    return true;
  }

  cogotoast.warn(alert, { position: 'bottom-right' });
  return false;
};

export const validateAtLeastTwoImages = validate(subs => subs.creatives.length > 1, 'You must select 2 images');
export const validateAtLeastTwoSearches = validate(searches => searches.length > 1, 'You need two or more searches');

export function generatePreview(
  page_id,
  account_id,
  link,
  mainCreative,
  subs,
  overrideLookup,
  endCard,
  placement,
) {
  return getPreview('generate_preview', {
    page_id,
    account_id,
    link,
    main_creative: mainCreative,
    image_sub_creatives: subs,
    override_lookup: overrideLookup,
    end_card: endCard,
    placement,
    instagram_actor_id,
  });
}

export function generateVideoPreview(
  page_id,
  account_id,
  link,
  mainCreative,
  subs,
  overrideLookup,
  placement,
) {
  return getPreview('generate_video_preview', {
    page_id,
    account_id,
    link,
    main_creative: mainCreative,
    image_sub_creatives: subs,
    override_lookup: overrideLookup,
    placement,
    instagram_actor_id,
  });
}

export function generateSinglePreview(
  page_id,
  account_id,
  link,
  mainCreative,
  subs,
  overrideLookup,
  placement,
) {
  return getPreview('generate_single_preview', {
    page_id,
    account_id,
    link,
    main_creative: mainCreative,
    image_sub_creatives: subs,
    override_lookup: overrideLookup,
    placement,
    instagram_actor_id,
  });
}

export function generateMultiPreview(
  page_id,
  account_id,
  mainCreative,
  subs,
  overrideLookup,
  endCard,
  placement,
) {
  return getPreview('generate_carousel_multi_preview', {
    page_id,
    account_id,
    main_creative: mainCreative,
    sub_creatives: subs,
    override_lookup: overrideLookup,
    end_card: endCard,
    placement,
    instagram_actor_id,
  });
}
